import { Link } from "react-router-dom";

import { HERSTELLER_LISTEN, type Hersteller, type HerstellerArt } from "@repo/shared";

/** Auswahl der vier Herstellerlisten – je Karte Titel, Beschreibung und Anzahl. */
export function ListenKarten({ hersteller }: { hersteller: Hersteller[] }) {
  const anzahl = (art: HerstellerArt) => hersteller.filter((h) => h.art === art && h.gelistet).length;
  return (
    <div className="kacheln">
      {HERSTELLER_LISTEN.map((liste) => (
        <Link key={liste.art} to={`/hersteller?liste=${liste.art}`} className="button kachel">
          <strong>{liste.titel}</strong>
          <span className="muted small">{liste.beschreibung}</span>
          <span className="small">{anzahl(liste.art).toLocaleString("de-DE")} Hersteller</span>
        </Link>
      ))}
    </div>
  );
}
